document.addEventListener("DOMContentLoaded", function () {
  const backToTopButtons = document.querySelectorAll(".back-to-top");
  backToTopButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });
  });
});

function syncFooterReadingOrder() {
  document.querySelectorAll('.footer__blocks-wrapper').forEach((wrapper) => {
    const newsletter = wrapper.querySelector('.footer-block--newsletter-item');
    if (!newsletter) return;
    newsletter.querySelectorAll('.footer-block__heading').forEach((heading) => {
      const desktop = window.matchMedia('(min-width: 750px)').matches;
      const hidden = heading.classList.contains(desktop ? 'hide-on-desktop' : 'hide-on-mobile');
      heading.setAttribute('aria-hidden', String(hidden));
    });
    if (window.matchMedia('(min-width: 750px)').matches) {
      if (wrapper.lastElementChild !== newsletter) wrapper.append(newsletter);
    } else if (wrapper.firstElementChild !== newsletter) {
      wrapper.prepend(newsletter);
    }
  });
}
document.addEventListener('DOMContentLoaded', syncFooterReadingOrder);
document.addEventListener('shopify:section:load', syncFooterReadingOrder);
window.matchMedia('(min-width: 750px)').addEventListener('change', syncFooterReadingOrder);

// iOS Safari colours the strip under its bottom bar from the page background (see the footer section's
// styles). That colour should only turn pink while the footer is on screen; elsewhere the bar would fade the
// page content into pink.
function watchFooterInView() {
  if (!('IntersectionObserver' in window) || !CSS.supports('-webkit-touch-callout', 'none')) return;
  const footer = document.querySelector('footer.footer');
  if (!footer) return;
  // Entries can arrive batched (a busy page that reaches the footer before the first callback has run gets
  // "off screen" then "on screen"); only the last one is current.
  new IntersectionObserver((entries) => {
    document.documentElement.classList.toggle('footer-in-view', entries[entries.length - 1].isIntersecting);
  }).observe(footer);
}
document.addEventListener('DOMContentLoaded', watchFooterInView);
